module.exports = __webpack_public_path__ + "img/upload.195b74d6.svg";